import { BankAccount } from "./bank-account";
import { Member } from "./member";
import { OrganisationSettings } from "./organisation-settings";
import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
  parseList,
} from "./model-utils";
import { enumValue, OrgStatus } from "./enums";

export class Organisation {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.orgId = asString(json.orgId);
    this.orgName = asString(json.orgName);
    this.orgReadId = asString(json.orgReadId);
    this.totalMembers = asNumber(json.totalMembers);
    this.sector = asString(json.sector);
    this.category = asString(json.category);
    this.logoUrl = asString(json.logoUrl);
    this.createdAt = asDate(json.createdAt);
    this.dateOfRequest = asDate(json.dateOfRequest);
    this.dateFounded = asDate(json.dateFounded);
    this.declineReason = asString(json.declineReason);
    this.deactivateReason = asString(json.deactivateReason);
    this.description = asString(json.description);
    this.email = asString(json.email);
    this.phone = asString(json.phone);
    this.intCode = asString(json.intCode);
    this.emailVerified = asBoolean(json.emailVerified);
    this.phoneVerified = asBoolean(json.phoneVerified);
    this.currency = asString(json.currency);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.address = asString(json.address);
    this.handle = asString(json.handle);
    this.rules = asString(json.rules);
    this.overAYear = asBoolean(json.overAYear);
    this.webLink = asString(json.webLink);
    this.tinyUrl = asString(json.tinyUrl);
    this.timezone = asString(json.timezone);
    this.taxNo = asString(json.taxNo);
    this.verified = asBoolean(json.verified);
    this.status = enumValue(OrgStatus, json.status);
    this.estimatedSize = asNumber(json.estimatedSize);
    this.coverPhoto = asString(json.coverPhoto);
    this.settings = OrganisationSettings.fromJson(json.settings);
    this.member = Member.fromJson(json.member);
    this.userInfor = Member.fromJson(json.userInfor);
    this.owner = Member.fromJson(json.owner);
    this.activeMemberInfo = Member.fromJson(json.activeMemberInfo);
    this.accountManager = isObject(json.accountManager)
      ? { ...json.accountManager }
      : json.accountManager;
    this.social = isObject(json.social) ? { ...json.social } : json.social;
    this.productIntrest = isObject(json.productIntrest)
      ? { ...json.productIntrest }
      : json.productIntrest;
    this.invoiceBankAccount = parseList(
      json.invoiceBankAccount,
      BankAccount.fromJson,
    );
    this.bankAccount = parseList(json.bankAccount, BankAccount.fromJson);
  }

  static fromJson(json: any) {
    return isObject(json) ? new Organisation(json) : json;
  }
}
